import { Dispatcher } from '../dispatcher/Dispatcher';
import { ActionTypes } from '../constants/ActionTypes';

export const UserServerActionCreators = {
  updateUser: (user) => {
    Dispatcher.dispatch({
      type: ActionTypes.USER_UPDATE,
      user,
    });
  },
  updateUsers: (users) => {
    Dispatcher.dispatch({
      type: ActionTypes.USER_UPDATE_MANY,
      users,
    });
  },
  setCurrentUser: (profileName) => {
    Dispatcher.dispatch({
      type: ActionTypes.USER_SET_CURRENT,
      profileName,
    });
  },
};
